import axios from "axios";
import { bun_server } from "./baseUrl";
import { set_error } from "./errorActions";

// import { geoServerBaseUrl } from "./baseUrl";

// const SERVER_URL = geoServerBaseUrl;

/*NON-API*/

export const set_loading = (loading_item) => {
  return {
    type: "set_loading_layer",
    payload: loading_item,
  };
};

export const clear_loading = () => {
  return {
    type: "clear_loading_layer",
  };
};

/*POST METHODE*/

export const set_data_premium_bulk = (body) => async (dispatch) => {
  //set_data_premium_bulk
  /*
const body = {
  geo_project_id,
  layer_id_array,
  price
}
*/
  try {
    dispatch({
      type: "set_loading_action",
      payload: "set_data_premium_bulk",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(
      bun_server + "/moneys_bun/set_data_premium_bulk",
      body,
      config
    );
    dispatch({
      type: "set_data_premium_bulk",
      payload: body,
    });
    dispatch({
      type: "set_project_premium",
      payload: body,
    });
    dispatch({
      type: "clear_loading_action",
      payload: "set_data_premium_bulk",
    });
    dispatch({
      type: "status_action",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "set_data_premium_bulk",
    });
  }
};

export const undo_data_premium_bulk = (body) => async (dispatch) => {
  //undo_data_premium_bulk
  /*
const body = {
  geo_project_id,
  layer_id_array
}
*/
  try {
    dispatch({
      type: "set_loading_action",
      payload: "undo_data_premium_bulk",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.post(
      bun_server + "/moneys_bun/undo_data_premium_bulk",
      body,
      config
    );
    dispatch({
      type: "undo_data_premium_bulk",
      payload: body,
    });
    dispatch({
      type: "undo_project_premium",
      payload: body,
    });
    dispatch({
      type: "clear_loading_action",
      payload: "undo_data_premium_bulk",
    });
    dispatch({
      type: "status_action",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "undo_data_premium_bulk",
    });
  }
};

/*GET METHODE*/

//get_data_premium_count
export const get_data_premium_count = () => async (dispatch) => {
  try {
    dispatch(set_loading("get_data_premium_count"));

    const res = await axios.get(
      bun_server + "/moneys_bun/get_data_premium_count"
    );

    dispatch({
      type: "get_data_premium_count",
      payload: res.data,
    });
    dispatch(clear_loading());
  } catch (error) {
    dispatch(clear_loading());
    dispatch(set_error(error));
  }
};

//search_data_premium
export const search_data_premium =
  (search_params, category_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      dispatch(set_loading("search_layer"));

      const params = new URLSearchParams();
      if (search_params) params.append("search_params", search_params);
      if (category_id) params.append("category_id", category_id);

      const queryParams = params.toString() ? `?${params.toString()}` : "";

      const res = await axios.get(
        bun_server + `/moneys_bun/search_data_premium_v2${queryParams}`,
        config
      );

      dispatch({
        type: "SEARCH_LAYER",
        payload: res.data?.layers,
      });
      dispatch(clear_loading());
    } catch (error) {
      dispatch(clear_loading());
      dispatch(set_error(error));
    }
  };

//load_more_search_data_premium
export const load_more_search_data_premium =
  (search_params = "", category_id, skip = 0) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      dispatch(set_loading("search_layer"));
      const params = new URLSearchParams();
      if (search_params) params.append("search_params", search_params);
      if (category_id) params.append("category_id", category_id);
      params.append("skip", skip);

      const queryParams = params.toString() ? `?${params.toString()}` : "";

      const res = await axios.get(
        bun_server + `/moneys_bun/load_more_search_data_premium${queryParams}`,
        config
      );

      dispatch({
        type: "LOAD_MORE_SEARCH_LAYER",
        payload: res.data?.layers,
      });
      dispatch(clear_loading());
    } catch (error) {
      dispatch(clear_loading());
      dispatch(set_error(error));
    }
  };

//get_data_premium_by_category_id
export const get_data_premium_by_category_id =
  (category_id, search_params, skip = 0) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      dispatch(set_loading("search_layer"));

      const params = new URLSearchParams();
      if (category_id) params.append("category_id", category_id);
      if (search_params) params.append("search_params", search_params);
      params.append("skip", skip);

      const queryParams = params.toString() ? `?${params.toString()}` : "";

      // }
      const res = await axios.get(
        bun_server +
          `/moneys_bun/get_data_premium_by_category_id${queryParams}`,
        config
      );

      dispatch({
        type: "SEARCH_LAYER",
        payload: res.data,
      });
      dispatch(clear_loading());
    } catch (error) {
      dispatch(clear_loading());
      dispatch(set_error(error));
    }
  };

export const get_data_premium_by_category_id_count =
  (search_params, category_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      dispatch(set_loading("search_layer"));

      const params = new URLSearchParams();
      if (category_id) params.append("category_id", category_id);
      if (search_params) params.append("search_params", search_params);

      const queryParams = params.toString() ? `?${params.toString()}` : "";

      const res = await axios.get(
        bun_server +
          `/moneys_bun/get_data_premium_by_category_id_count${queryParams}`,
        config
      );

      dispatch({
        type: "SEARCH_LAYER_COUNT",
        payload: res.data,
      });

      setTimeout(() => {
        dispatch(clear_loading());
      }, 1600);
    } catch (error) {
      dispatch(clear_loading());
      dispatch(set_error(error));
    }
  };

export const empty_data_premium_by_category_id = () => async (dispatch) => {
  try {
    dispatch({
      type: "SEARCH_LAYER",
      payload: [],
    });
  } catch (error) {
    dispatch(clear_loading());
    dispatch(set_error(error));
  }
};

export const reset_get_data_premium_by_category_id_count =
  () => async (dispatch) => {
    try {
      dispatch({
        type: "SEARCH_LAYER_COUNT",
        payload: 0,
      });
    } catch (error) {
      dispatch(clear_loading());
      dispatch(set_error(error));
    }
  };
